import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AutomapperService } from "../core/automapper/automapper.service";
import { BASE_API_URL } from "../core/environment.tokens";


@Injectable()
export class PlatformService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private readonly http: HttpClient,
    private readonly automapper: AutomapperService
  ) { }

  getMenu() {
    const url = `${this.baseApiUrl}Navigation/Metadata`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default", "MenuItem")));
  }
}
